import React from 'react';
import { Skeleton } from 'antd';

const SkeletonColumns = () => (
  <Skeleton.Input size="small" active paragraph={{ rows: 1 }} />
);

export default SkeletonColumns;
